const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        welcomeText:
            'Behalten Sie den Überblick über Ihre Spitaltermine und haben Sie jederzeit Zugriff auf alle wichtigen Informationen rund um Ihre Gesundheit mit dem Patientenportal des Zuger Kantonsspitals.',
    },
    __RELATIVE_SOURCE_FILE__
);
